import styled, { css } from 'styled-components'
import { TranslateIcon } from '@mote/assets/icons'
import { Dropdown } from '@mote/ui'
import React from 'react'
import { Control } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { useTranscriptTranslation } from './useTranscriptTranslation'

const Comparator = (a, b) => {
  if (a[1] < b[1]) return -1
  if (a[1] > b[1]) return 1
  return 0
}

export function MoteCardRichTranslateDropdown({
  onTranscriptLanguageUpdate,
  isCreator
}) {
  const { moteId, theme } = useMotePlayer()
  const { translations, translate } = useTranscriptTranslation(
    moteId,
    isCreator,
    onTranscriptLanguageUpdate
  )

  const translationOptions = React.useMemo(
    () =>
      translations.map(([languageCode, name]) => {
        return (
          <Dropdown.Item key={languageCode}>
            <Dropdown.ItemText>{name}</Dropdown.ItemText>
          </Dropdown.Item>
        )
      }),
    []
  )

  return (
    <Root
      id={`transcript-translation-languages-${moteId}`}
      variant='dark'
      width={240}
      height={4 * 40}
      onAction={translate}
      aria-label='Translate to...'
      triggerElement={
        <Trigger
          size={36}
          theme={theme?.button}
          tooltipProps={{
            content: 'Translate to...',
            direction: 'down-end',
            distance: 7
          }}
        >
          <TranslateIcon color='currentColor' />
        </Trigger>
      }
      placement='bottom-right'
      showChevron={false}
      returnFocusOnClose={false}
    >
      {translationOptions}
    </Root>
  )
}

const Root = styled(Dropdown)`
  .dropdown-container {
    scroll-snap-type: y proximity;
    padding: 0;
    z-index: 20;
  }

  li.dropdown-item {
    scroll-snap-align: start;
  }
`

const Trigger = styled(Control)`
  color: ${({ theme }) => theme?.color};

  svg {
    height: 24px;
    width: 24px;
  }

  &:hover,
  &:focus {
    color: ${({ theme }) => theme?.hover?.color};
    background: ${({ theme }) => theme?.hover?.background};
  }

  &:focus {
    box-shadow: 0 0 0 2px rgba(47, 166, 255, 0.6);
  }
`
